// extracted by mini-css-extract-plugin
export default {"link":"sz-z","disabled":"tz-z"};